<mat-card class="card-web" appearance="outlined">
    <mat-card-header>
    <div class="card-header-web">
      <img class="card-provider-image-web" src="{{photo}}">
      <div class="card-provider-wait-time-container-web">
        <div class="card-provider-book-as-soon-as-web">
            {{soonAsText}}
        </div>
        <div class="card-provider-availability-web" *ngIf="availability!=null&&availability!=''">
            {{waitTime}}
        </div>
      </div>
    </div>
    </mat-card-header>
    <mat-card-content class="card-provider-content-web">
      <mat-card-title *ngIf="name.length <= 25" class="card-provider-title-web">{{name}}</mat-card-title>
      <mat-card-title *ngIf="name.length > 25" class="card-provider-title-long-web">{{name}}</mat-card-title>
      <mat-card-subtitle class="card-provider-subtitle-web">{{specialties}}</mat-card-subtitle>
    </mat-card-content>
    <mat-card-actions class="card-provider-actions-web">
        <div class="card-provider-detail-bottom-left-web">{{virtualVisitText}}</div>
        <button mat-button class="action-button-primary" style="width: 111px; height: 39;" (click)="bookNow()">{{scheduleText}}</button>
    </mat-card-actions>
</mat-card>